<template>
  <div class="personal">
    <div class="step">
      <el-steps :active="active" finish-status="success" align-center>
        <el-step title="信息填写"></el-step>
        <el-step title="信息确认"></el-step>
        <el-step title="完成报名"></el-step>
      </el-steps>
    </div>
    <div class="step1 info" v-if="active === 1">
      <div class="tourist">
        <el-form
          :model="ruleForm"
          status-icon
          ref="ruleForm"
          class="demo-ruleForm"
          label-width="2rem"
        >
          <p>预约人信息</p>
          <div
            v-for="(item, index) in ruleForm.people"
            class="column"
            @touchstart.capture="start($event, index)"
            @touchend.capture="end($event, index)"
          >
            <div class="delete" data-type="0">
              <div class="remove" @click="remove(item)">
                <span>删除</span>
              </div>
            </div>
            <div class="info-list-item">
              <div class="info_icon1">
                <img :src="nameList[0].icon" height="100%" width="100%" />
              </div>
              <el-form-item
                :label="nameList[0].title"
                :prop="'people.' + index + '.name'"
                :rules="{
                  required: true,
                  message: '姓名不能为空',
                  trigger: 'blur'
                }"
              >
                <el-input
                  v-model="item.name"
                  @blur="blur"
                  placeholder="请输入姓名"
                ></el-input>
              </el-form-item>
            </div>
            <!--            手机号-->
            <div class="info-list-item">
              <div class="info_icon1">
                <img :src="nameList[1].icon" width="100%" height="100%" />
              </div>
              <el-form-item
                :label="nameList[1].title"
                :prop="'people.' + index + '.phoneNumber'"
                :rules="[
                  {
                    required: true,
                    message: '手机号不能为空',
                    trigger: 'blur'
                  },
                  {
                    pattern: /^1[0-9]{10}$/,
                    message: '手机号格式不对',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  v-model.number="item.phoneNumber"
                  maxlength="11"
                  @blur="blur"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
            </div>
            <!--            身份证-->
            <div class="info-list-item" v-show="iscard">
              <div class="info_icon1">
                <img :src="nameList[2].icon" width="100%" height="100%" />
              </div>
              <el-form-item
                :label="nameList[2].title"
                :prop="'people.' + index + '.identityCard'"
                :rules="[
                  {
                    required: true,
                    message: '身份证号不能为空',
                    trigger: 'blur'
                  },
                  {
                    pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                    message: '身份证号格式不对',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  v-model="item.identityCard"
                  maxlength="18"
                  @blur="blur"
                  placeholder="请输入身份证号"
                ></el-input>
              </el-form-item>
            </div>
            <!--          是否携带儿童-->
            <!-- <div class="info-list-item info-list-item1">
              <div class="info_icon">
                <img :src="childen.icon" width="100%" height="100%" />
              </div>
              <span class="info_title">{{ childen.title }}</span>
              <el-input-number
                v-model="item.carryChild"
                @change="handleChange"
                :min="0"
                :max="10"
                label="描述文字"
              ></el-input-number>
            </div> -->
            <!--            验证码-->
            <div
              class="info-list-item info-list-item2"
              v-if="index === 0"
              v-show="noToken"
            >
              <div class="info_icon1">
                <img :src="nameList[3].icon" width="100%" height="100%" />
              </div>
              <el-form-item
                :label="nameList[3].title"
                :prop="'people.' + index + '.phoneNumber'"
                :rules="[
                  {
                    required: true,
                    message: '验证码不能为空',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  v-model.number="smsCode"
                  maxlength="6"
                  @blur="blur"
                  placeholder="验证码"
                ></el-input>
                <span
                  v-show="sendAuthCode"
                  class="smscode"
                  @click="getVerificationCode"
                  >获取验证码</span
                >
                <span class="smscode nosmscode" v-show="!sendAuthCode"
                  >{{ auth_time }}S后重新获取</span
                >
              </el-form-item>
            </div>
            <div class="line"></div>
          </div>
          <div class="addinfo">
            <span role="button" class="add" @click="addInfo">
              <i class="el-icon-plus"></i>
            </span>
            <span>添加预约人信息</span>
          </div>
        </el-form>
      </div>
      <div class="next" style="margin: 1rem auto;width: 2rem;">
        <el-button @click="next">下一步</el-button>
      </div>
    </div>
    <div class="step2 info" v-if="active === 2">
      <div class="tourist">
        <p>活动信息</p>
        <!--        <infolist :id="uid" ref="infolist1"></infolist>-->
        <div class="info-list">
          <ul>
            <li
              v-for="(item, index) in itemList1"
              :key="index"
              class="info-list-item"
            >
              <span class="info_title">
                <div class="info_icon">
                  <img :src="item.icon" width="100%" height="100%" />
                </div>
                <p>{{ item.title }}</p>
              </span>
              <span class="info_text">{{ item.text }}</span>
            </li>
          </ul>
          <div class="line"></div>
        </div>
        <p>预约人信息</p>
        <div v-for="(item, index) in ruleForm.people" class="info-group">
          <div class="info-list-item">
            <div class="info_icon">
              <img :src="nameList[0].icon" height="100%" width="100%" />
            </div>
            <span class="info_title">{{ nameList[0].title }}</span>
            <span class="info_text">{{ ruleForm.people[index].name }}</span>
          </div>
          <div class="info-list-item">
            <div class="info_icon">
              <img :src="nameList[1].icon" height="100%" width="100%" />
            </div>
            <span class="info_title">{{ nameList[1].title }}</span>
            <span class="info_text"
              >{{ ruleForm.people[index].phoneNumber }}
            </span>
          </div>
          <div class="info-list-item" v-show="iscard">
            <div class="info_icon">
              <img :src="nameList[2].icon" height="100%" width="100%" />
            </div>
            <span class="info_title">{{ nameList[2].title }}</span>
            <span class="info_text"
              >{{ ruleForm.people[index].identityCard }}
            </span>
          </div>
          <!-- <div class="info-list-item">
            <div class="info_icon">
              <img :src="childen.icon" height="100%" width="100%" />
            </div>
            <span class="info_title">{{ childen.title }}</span>
            <span class="info_text">{{ ruleForm.people[0].carryChild }}</span>
          </div> -->
        </div>
        <div class="line"></div>
      </div>
      <div class="button">
        <el-button style="margin-right: 2rem;" @click="prev">修改</el-button>
        <el-button @click="postInfo">确认</el-button>
      </div>
    </div>
    <div class="step3 info" v-if="active === 3">
      <div
        class="imageWrapper"
        ref="imageWrapper"
        v-show="firstFlag"
        style="background: url(./static/images/card.png) no-repeat;background-size:100% 10.8rem;"
        @click="toImage"
      >
        <div class="affirm-info">
          <div class="acti-img">
            <img
              id="scream"
              height="100%"
              width="100%"
              :src="getImage(infoList.image)"
              crossorigin="anonymous"
              style="display: none;"
            />
            <img
              id="scream1"
              height="100%"
              width="100%"
              :src="imgurl"
              crossorigin="anonymous"
            />
            <!--            <canvas id="myCanvas" width="250" height="300" style="position: relative; z-index: 100">1111</canvas>-->
          </div>
          <div v-for="(actiinfo, index) in actiinfoList" class="actiinfo">
            <span>{{ actiinfo.title }}</span>
            <span class="actitext">{{ actiinfo.text }}</span>
          </div>
        </div>
        <div class="more-acti">
          <div class="more">
            <img
              :src="more.img"
              crossorigin="anonymous"
              width="100%"
              height="100%"
            />
          </div>
          <!--          <img :src="code.img" alt="" class="code" crossorigin="anonymous">-->
          <qrcode :id="uid"></qrcode>
        </div>
      </div>
      <!--遮罩-->
      <div class="mask" v-show="maskShow" @click="setMaskShow"></div>
      <div class="real_pic" v-show="!firstFlag">
        <img
          ref="real_pic"
          :src="dataURL"
          v-show="!firstFlag"
          width="100%"
          height="100%"
        />
      </div>
      <div class="share">
        <img src="@/assets/icons/share.png" width="100%" height="100%" />
      </div>
    </div>
  </div>
</template>
<script>
// import {prevent} from '../utils';
import html2canvas from "html2canvas";
import qrcode from "@/components/qrCode/qrCode";
import Vue from "vue";
export default {
  name: "personalinfo",
  props: ["id"],
  components: { qrcode },
  data() {
    return {
      flag: false,
      active: 1,
      text: "",
      textarea: "",
      dataURL: "",
      firstFlag: true,
      maskShow: false,
      visible: false,
      count: 0,
      uid: this.id,
      infoList: "",
      imgurl: "",
      base64Url: "",
      nameList: [
        {
          title: "姓名",
          icon: "./static/images/icons/people.png",
          text: "",
          prop: "name"
        },
        {
          title: "手机号",
          icon: "./static/images/icons/tel.png",
          text: "",
          prop: "phoneNumber"
        },
        {
          title: "身份证号",
          icon: "./static/images/icons/idcard.png",
          text: "",
          prop: "identityCard"
        },
        {
          title: "验证码",
          icon: "./static/images/icons/smsCode.png",
          text: "",
          prop: "smsCode"
        }
      ],
      childen: {
        title: "携带儿童",
        icon: "./static/images/icons/childen.png",
        text: ""
      },
      imgList: "",
      actiinfoList: [
        {
          title: "活动名称",
          icon: "./static/images/icons/people.png",
          text: ""
        },
        {
          title: "活动时间",
          icon: "./static/images/icons/time1.png",
          text: ""
        },
        { title: "活动地点", icon: "./static/images/icons/place.png", text: "" }
      ],
      code: { img: "./static/images/code.png" },
      more: { img: "./static/images/more.png" },
      ruleForm: {
        people: [
          {
            name: "",
            phoneNumber: "",
            identityCard: "",
            carryChild: ""
          }
        ]
      },
      itemList1: [
        {
          title: "活动名称",
          icon: "./static/images/icons/activity.png",
          text: ""
        },
        {
          title: "活动时间",
          icon: "./static/images/icons/time1.png",
          text: ""
        },
        {
          title: "活动地点",
          icon: "./static/images/icons/place.png",
          text: ""
        },
        { title: "联系电话", icon: "./static/images/icons/tel.png", text: "" }
      ],
      iscard: "", //是否需要身份证号
      smsCode: "", //验证码
      sendAuthCode: true /*布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */,
      auth_time: 30 /*倒计时 计数器*/,
      noToken: false
    };
  },
  methods: {
    getQueryStringRegExp: function getQueryStringRegExp(name) {
      var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
      if (reg.test(location.href))
        return unescape(RegExp.$2.replace(/\+/g, " "));
      return "";
    },
    prev() {
      --this.active;
      if (this.active < 0) this.active = 0;
    },
    next() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.active++ > 2) this.active = 0;
          if (this.getCookie("code") === undefined) {
            console.log(this.getCookie("code"));
            this.login();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleChange(value) {
      console.log(value);
    },
    // 添加参观者信息
    addInfo() {
      if (this.iscard === false) {
        let timestamp = new Date().getTime();
        this.ruleForm.people.push({
          name: "",
          phoneNumber: "",
          identityCard: timestamp,
          carryChild: ""
        });
      } else {
        this.ruleForm.people.push({
          name: "",
          phoneNumber: "",
          identityCard: "",
          carryChild: ""
        });
      }
      console.log(this.ruleForm);
    },
    remove(item) {
      this.ruleForm.people.splice(this.ruleForm.people.indexOf(item), 1);
      this.restSlide();
    },
    // 转换成电子凭据
    toImage() {
      this.count++;
      if (this.count > 1) {
        alert("您已经保存过图片");
      } else {
        let width = this.$refs.imageWrapper.offsetWidth;
        let height = this.$refs.imageWrapper.offsetHeight;
        // var scale = 1;
        window.scrollTo(0, 0); //解决ios截图偏移的问题
        window.onload = html2canvas(this.$refs.imageWrapper, {
          backgroundColor: null,
          useCORS: true, //（图片跨域相关）
          // scale:scale,
          width: width,
          heigth: height,
          allowTaint: true, //允许跨域（图片跨域相关）
          taintTest: true //是否在渲染前测试图片
        }).then(canvas => {
          let dataURL = canvas.toDataURL("image/png");
          // let dataURL = canvas.toDataURL("image/jpeg");
          this.dataURL = dataURL;
          this.firstFlag = false;
          this.maskShow = !this.maskShow;
          alert("点击确定后长按图片保存");
        });
      }
    },
    setMaskShow() {
      this.maskShow = !this.maskShow;
    },
    //获取验证码
    getVerificationCode() {
      this.$axios
        .get(
          window.SITE_CONFIG.baseUrl +
            "/api/message/send/verification-code?phoneNumber=" +
            this.ruleForm.people[0].phoneNumber
        )
        .then(({ data }) => {
          // console.log(data);
          alert(data.data);
        });
      this.sendAuthCode = false;
      this.auth_time = 30;
      const auth_timetimer = setInterval(() => {
        this.auth_time--;
        if (this.auth_time <= 0) {
          this.sendAuthCode = true;
          clearInterval(auth_timetimer);
        }
      }, 1000);
    },
    login() {
      var _this = this;
      console.log("手机号", this.smsCode);
      this.$axios({
        method: "post",
        url: window.SITE_CONFIG.baseUrl + "/api/auth/jwt/member-token",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        },
        data: JSON.stringify({
          mobilePhone: this.ruleForm.people[0].phoneNumber,
          authCode: this.smsCode
        })
      }).then(function(response) {
        console.log("是否成功", response.data);
        console.log("是否成功", response.status);
        if (response.status === 200) {
          // console.log(_this.ruleForm.people[0].phoneNumber);
          _this.setCookie("code", response.data, 14400);
          _this.setCookie("phoneNumber", _this.ruleForm.people[0].phoneNumber, 14400);
        }
      });
    },
    //提交信息
    postInfo() {
      // console.log(this.ruleForm);
      this.$axios
        .post(
          window.SITE_CONFIG.baseUrl +
            "/api/activity/web/activity/registration/" +
            this.uid,
          this.ruleForm.people,
          {
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              Authorization: this.getCookie("code")
            }
          }
        )
        .then(({ data }) => {
          console.log(data);
          console.log(data.data);
          if (data.rel === false) {
            alert(data.data);
          } else {
            alert(data.data);
            this.$router.replace('/myOrder')
          }
        });
    },
    // 获取活动列表
    getitemList() {
      this.$axios
        .get(
          window.SITE_CONFIG.baseUrl + "/api/activity/web/activity/" + this.uid
        )
        .then(response => {
          var result = response.data;
          this.infoList = result.data;
          this.iscard = result.data.status;
          this.itemList1[0].text = result.data.activityName;
          this.itemList1[1].text =
            result.data.startTime.substring(0, 16) +
            "~" +
            result.data.endTime.substring(0, 16);
          this.itemList1[2].text = result.data.location;
          this.itemList1[3].text = result.data.phoneNumber;
          this.actiinfoList[0].text = result.data.activityName;
          this.actiinfoList[2].text = result.data.location;
          this.actiinfoList[1].text =
            result.data.startTime.substring(0, 16) +
            "~" +
            result.data.endTime.substring(0, 16);
        });
    },
    //获取用户注册过的基本信息
    getBasicInfo: function getBasicInfo() {
      var _this = this;
      this.$axios
        .get(window.SITE_CONFIG.baseUrl + "/api/volunteer/web/volunteer/info", {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: this.getCookie("code")
          }
        })
        .then(function(response) {
          console.log(response.data.status);
          console.log(window.__wxjs_environment === "miniprogram"); // true
          //小程序中登录过期返回个人中心
          if (
            response.data.status === 40101 &&
            window.__wxjs_environment === "miniprogram"
          ) {
            alert("登录过期，请返回个人中心重新登录");
            wx.miniProgram.navigateTo({ url: "../../pages/login/login" });
            // wx.miniProgram.postMessage({ type: 'activity' })
          } else if (
            response.data.status === 40101 &&
            window.__wxjs_environment !== "miniprogram"
          ) {
            //判断token是否过期
            // _this.setCookie("code", '', 0);
            // _this.setCookie("phoneNumber", '', 0);
            // alert(_this.getCookie("code"))
            Vue.cookie.delete("code");
            Vue.cookie.delete("phoneNumber");
            // alert(_this.getCookie("code"))
            // $.cookie("code", '', {expires:-1})
            // $.cookie("phoneNumber", '', {expires:-1})
            _this.$router.push({
              name: "myOrder"
            });
          } else if (response.data.rel === true) {
            _this.isLogin = true;
            // _this.ruleForm.people[0] = response.data.data
            _this.ruleForm.people[0].name = response.data.data.realName;
            _this.ruleForm.people[0].phoneNumber =
              response.data.data.phoneNumber;
            _this.ruleForm.people[0].identityCard =
              response.data.data.identityCard;
          } else {
            _this.isRegister = true;
          }
          console.log(response.status);
        });
    },
    getImage(val) {
      // alert(val)
      const _this = this;
      var date = new Date();
      var h = date.getHours(); //获取小时
      var m = date.getMinutes(); //获取分钟
      var s = date.getSeconds(); //获取秒
      let imgArr = val.split(";");
      // alert(imgArr[0])
      let imgnew = "";
      // this.imgurl = window.SITE_CONFIG.baseUrl+imgArr[0]+'?'+h+m+s;
      this.convertImgToBase64(
        window.SITE_CONFIG.fileBaseApi + imgArr[0] + "?" + h + m + s,
        function(base64Img) {
          // console.log(base64Img);
          if ((this.flag = true)) {
            // console.log(2)
            // console.log(_this.imgurl)
            _this.imgurl = base64Img;
            return _this.imgurl;
          }
        }
      );
    },
    convertImgToBase64(url, callback, outputFormat) {
      var canvas = document.createElement("canvas"),
        ctx = canvas.getContext("2d"),
        img = new Image();
      img.crossOrigin = "Anonymous"; //它开启了本地的跨域允许。当然服务器存储那边也要开放相应的权限才行，如果是设置了防盗链的图片在服务端就没有相应的权限的话你本地端开启了权限也是没有用的
      img.onload = function() {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL(outputFormat || "image/png"); //没权限的跨域图片在使用canvas.toDataURL()数据导出时会报错
        callback.call(this, dataURL);
        canvas = null;
      };
      img.src = url;
      this.flag = true;
      // console.log(4)
    },
    blur() {
      setTimeout(function() {
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
        console.log(1);
      }, 100);
    },
    // 左滑删除
    start(e, i) {
      this.startX = e.touches[0].clientX;
      console.log(e);
      console.log(i);
    },
    end(e, i) {
      console.log(i);
      // 当前滑动的父级元素
      // let parentElement = e.currentTarget.parentElement;
      // 记录结束位置
      // console.log(e);
      this.endX = e.changedTouches[0].clientX;
      console.log(this.endX);
      // 左滑
      if (this.startX - this.endX > 30) {
        // this.restSlide();
        console.log("左滑");
        this.restSlide();
        e.currentTarget.children[0].dataset.type = 1;
      }
      // 右滑
      if (this.startX - this.endX < -30) {
        // this.restSlide();
        console.log("右滑");
        this.restSlide();
        e.currentTarget.children[0].dataset.type = 0;
      }
      this.startX = 0;
      this.endX = 0;
    },
    //复位滑动状态
    restSlide() {
      let listItems = document.querySelectorAll(".delete");
      // 复位
      for (let i = 0; i < listItems.length; i++) {
        listItems[i].dataset.type = 0;
      }
    },
    //  控制进度条长度
    step() {
      var step = document.getElementsByClassName("el-step__line");
      console.log(step.length);
      step[0].style.width = "2.64rem";
      step[0].style.left = "0.71rem";
      step[0].style.borderRadius = "6px 0 0 6px";
      step[0].style.borderRightColor = "#fff";
      step[1].style.borderLeftColor = "#fff";
      step[1].style.borderRight = "none";
      step[2].style.width = "2.64rem";
      step[2].style.borderLeft = "none";
      step[2].style.borderRadius = "0 20px 20px 0";
    },
    getCookie: function(cookie_name) {
      var allcookies = document.cookie;
      //索引长度，开始索引的位置
      var cookie_pos = allcookies.indexOf(cookie_name);

      // 如果找到了索引，就代表cookie存在,否则不存在
      if (cookie_pos !== -1) {
        // 把cookie_pos放在值的开始，只要给值加1即可
        //计算取cookie值得开始索引，加的1为“=”
        cookie_pos = cookie_pos + cookie_name.length + 1;
        //计算取cookie值得结束索引
        var cookie_end = allcookies.indexOf(";", cookie_pos);

        if (cookie_end === -1) {
          cookie_end = allcookies.length;
        }
        //得到想要的cookie的值
        var value = unescape(allcookies.substring(cookie_pos, cookie_end));
      }
      return value;
    },
    //设置cookie时间以秒为单位
    setCookie(c_name, value, expireseconds) {
      var exdate = new Date();
      exdate.setTime(exdate.getTime() + expireseconds * 1000);
      document.cookie =
        c_name +
        "=" +
        escape(value) +
        (expireseconds == null ? "" : ";expires=" + exdate.toGMTString()) +
        ";path=/";
    }
  },
  mounted() {
    this.getitemList();
    this.step();
    console.log(this.$store.state.token);
    if (this.getCookie("code")) {
      console.log("是否有code", this.getCookie("code"));
      this.getBasicInfo();
    } else {
      this.noToken = true;
    }
  },
  watch: {
    active() {
      this.$nextTick(function() {
        if (this.active === 3) {
          console.log("变窄");
          document.querySelectorAll(".step")[0].style.borderRadius = "0";
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/personalInfo/personalInfo.vue